export default __webpack_public_path__ + "logo.2ad8cd52a660328e8b852537d138a361.png";